/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Form,
  Row,
  Col,
  Spin,
  Card,
  Input,
  Button,
} from 'antd';
import { CheckCircleOutlined, SearchOutlined } from '@ant-design/icons';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import CurrencyInput from 'components/CurrencyInput';
import currencyFormatter from 'utils/currencyFormatter';
import Select from 'components/Select';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import CustomSearch from 'components/customSearch';
import { formatReceived } from 'utils/formatValues';
import { checkToken } from 'api/utils';
import { onError } from 'utils/handlers';
import {
  getDescuentosNoAplicados,
  getDescuentoNoAplicado,
  postDescuentoNoAplicado,
  patchDescuentoNoAplicado,
  deleteDescuentoNoAplicado,
} from 'api/nominas/descuentos/descuentosNoAplicados';
import { getEmpleadosConDatosOpFilteredPaginated, getEmpleadosOptimized } from 'api/estructuraOrganizacional/empleados';
import { getPlazasvistaOptimized } from 'api/catalogos/plazas';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getDescuentos } from 'api/nominas/descuentos/descuentos';
import { getConfiguracionDescuentos } from 'api/nominas/descuentos/configuracionDescuentos';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { getEstadosGlobales } from 'api/catalogos';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const descuentosNoAplicadosPermission = {
  permissionModel: 'descuentonominanoaplicado',
  catalogsModels: [],
  tabsModels: [],
};

const DescuentosNoAplicados = ({ permission }) => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [open, setVisible] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [confirmationVisible, setConfirmationVisible] = useState(false);

  const [empleados, setEmpleados] = useState([]);
  const [plazas, setPlazas] = useState([]);
  const [datosOperacionales, setDatosOperacionales] = useState([]);
  const [descuentosEmpleados, setDescuentosEmpleados] = useState([]);
  const [periodos, setPeriodos] = useState([]);
  const [periodosNominas, setPeriodosNominas] = useState([]);
  const [estados, setEstados] = useState([]);
  const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);

  const [empleado, setEmpleado] = useState();
  const [puesto, setPuesto] = useState('');
  const [area, setArea] = useState('');
  const [plaza, setPlaza] = useState('');

  const [openSearch, setVisibleSearch] = useState(false);
  const [dataSearch, setDataSearch] = useState([]);
  const [baseURIPagination, setBaseURIPagination] = useState();
  const [selectedEmpleadoSearch, setSelectedEmpleadoSearch] = useState();

  let baseURIDatosOpPaginado = 'catalogos/dato-operacional-del-empleado-paginado/?empleados_filter=';

  const fetchData = async (params = {}) => {
    setLoading(true);
    const _data = await getDescuentosNoAplicados(params);
    setData(formatReceived(Array.isArray(_data) ? _data : (_data?.results || [])));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _empleados,
        _plazas,
        _datosOperacionales,
        _periodos,
        _periodosNominas,
        _estados,
        _tiposNominaEmpleado,
        _data,
      ] = await Promise.all([
        getEmpleadosOptimized(),
        getPlazasvistaOptimized(),
        getDatoOperacionalesDeEmpleados(),
        getPeriodosDeNominasDetalles(),
        getPeriodosDeNominas({ estados_globales: ESTATUS_AUTORIZADO }),
        getEstadosGlobales(),
        getTiposDeNominasEmpleados(),
        getDescuentosNoAplicados(),
      ]);
      if (mounted) {
        setEmpleados(_empleados);
        setPlazas(_plazas);
        setDatosOperacionales(_datosOperacionales);
        setPeriodos(_periodos.filter((p) => _periodosNominas.some((pn) => pn.id === p?.periodo_de_nomina)));
        setPeriodosNominas(_periodosNominas);
        setEstados(_estados);
        setTiposDeNominaEmpleado(_tiposNominaEmpleado);
        setData(formatReceived(Array.isArray(_data) ? _data : (_data?.results || [])));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(false);
    form.resetFields();
    setDescuentosEmpleados([]);
    setPuesto('');
    setArea('');
    setPlaza('');
    setEmpleado();
    setSelectedEmpleadoSearch();
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true); // Abre la vista 2 (Formulario con botones Guardar)
  };

  // Obtiene plaza del empleado a partir de datosOperacionales
  const getPlazaEmpleado = (idEmpleado) => {
    const _datoOp = datosOperacionales?.find((e) => e.empleado === idEmpleado);
    return plazas?.find((p) => p.id === _datoOp?.plaza);
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _record = await getDescuentoNoAplicado(match.id);
    if (_record) {
      const _descuentosEmp = await getDescuentos({ empleado: _record.empleado });
      setDescuentosEmpleados(_descuentosEmp?.results || _descuentosEmp || []);

      // Llenamos la información visual del empleado
      const empObj = empleados.find((e) => e.id === _record.empleado);
      if (empObj) {
        const _plaza = getPlazaEmpleado(empObj.id);
        setPuesto(_plaza?.puesto_descripcion || '');
        setArea(_plaza?.directorio_area_clave_y_nombre || '');
        setPlaza(_plaza?.clave || '');
        setEmpleado(empObj.id);
      }

      setTimeout(() => {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue({
            ...formatReceived(_record),
            empleado: _record.empleado, // Campo oculto con el ID real
            empleado_search: empObj ? `${empObj.numero_de_empleado} - ${empObj.nombre} ${empObj.apellido_paterno} ${empObj.apellido_materno}` : '',
          });
          setVisible(true); // Abre la vista del form
        });
      });
    }
    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = { ...form.getFieldsValue() };

      // Eliminamos el campo visual antes de mandar al backend
      delete values.empleado_search;

      const [key] = selectedRowKeys;
      if (!key) delete values.id;

      const saved = await (key
        ? patchDescuentoNoAplicado(key, values)
        : postDescuentoNoAplicado(values));

      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteDescuentoNoAplicado(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishConfirmation = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      const res = await patchDescuentoNoAplicado(key, { estados_globales: ESTATUS_AUTORIZADO });
      if (res) {
        await fetchData();
        setConfirmationVisible(false);
        setSelectedRowKeys([]);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
  };

  const rowSelection = { selectedRowKeys, type: 'radio' };

  const onChangeEmpleado = (value) => {
    if (value) {
      const empleadoId = typeof value === 'object' ? value?.id : value;
      const _plaza = getPlazaEmpleado(empleadoId);

      setPuesto(_plaza?.puesto_descripcion || '');
      setArea(_plaza?.directorio_area_clave_y_nombre || '');
      setPlaza(_plaza?.clave || '');
      setEmpleado(empleadoId);

      // Seteamos el texto de la lupa
      const empObj = typeof value === 'object' ? value : empleados.find((e) => e.id === empleadoId);
      if (empObj) {
        form.setFieldsValue({
          empleado: empleadoId, // Guardamos el ID internamente
          empleado_search: `${empObj.numero_de_empleado || ''} - ${empObj.nombre || ''} ${empObj.apellido_paterno || ''} ${empObj.apellido_materno || ''}`,
        });
      }

      form.resetFields(['descuento_empleado']);
      setDescuentosEmpleados([]);
      getDescuentos({ empleado: empleadoId }).then((_d) => {
        setDescuentosEmpleados(_d?.results || _d || []);
      });
    }
  };

  const searchData = async (empId, nombreEmp, apPatEmp, apMatEmp, tipoNominaEmpleado) => {
    setLoading(true);
    if (empId) baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}numero_de_empleado=${empId};`;
    if (nombreEmp) baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}nombre=${nombreEmp};`;
    if (apPatEmp) baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_paterno=${apPatEmp};`;
    if (apMatEmp) baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_materno=${apMatEmp};`;
    if (tipoNominaEmpleado) baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}&tipo_de_nomina_empleado=${tipoNominaEmpleado}&`;
    setBaseURIPagination(baseURIDatosOpPaginado);
    const _empleados = await getEmpleadosConDatosOpFilteredPaginated(baseURIDatosOpPaginado);
    setDataSearch(_empleados);
    return setLoading(false);
  };

  const requiredRule = { required: true, message: 'El campo es requerido' };
  const rules = { required: [requiredRule], estatus: [requiredRule] };

  const columnsEmpleado = [
    {
      titleText: 'No. de Empleado', dataIndex: 'empleado', key: 'emp_num', width: 160, render: (e) => e?.numero_de_empleado,
    },
    {
      titleText: 'Nombre', dataIndex: 'empleado', key: 'emp_nom', width: 220, render: (e) => e?.nombre,
    },
    {
      titleText: 'Apellido Paterno', dataIndex: 'empleado', key: 'emp_pat', width: 220, render: (e) => e?.apellido_paterno,
    },
    {
      titleText: 'Apellido Materno', dataIndex: 'empleado', key: 'emp_mat', width: 220, render: (e) => e?.apellido_materno,
    },
    {
      titleText: 'Tipo de Nómina Empleado', dataIndex: 'tipo_de_nomina_empleado', key: 'tipo_nomina', width: 240, render: (val) => tiposDeNominaEmpleado?.find((t) => t?.id === val)?.descripcion,
    },
  ];

  const columns = [
    {
      titleText: 'No. de Nómina', dataIndex: 'nomina', key: 'nomina', width: 150,
    },
    {
      titleText: 'Periodo de Nómina', dataIndex: 'periodo_descripcion', key: 'periodo_descripcion', width: 280,
    },
    {
      titleText: 'No. de Descuento', dataIndex: 'descuento_empleado', key: 'descuento_empleado', width: 150,
    },
    {
      titleText: 'Importe del Descuento', dataIndex: 'importe_descuento', key: 'importe_descuento', width: 200, align: 'right', render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Importe Aplicado', dataIndex: 'importe_aplicado', key: 'importe_aplicado', width: 180, align: 'right', render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Importe No Aplicado', dataIndex: 'importe_no_aplicado', key: 'importe_no_aplicado', width: 180, align: 'right', render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'No. de Nómina de Aplicación', dataIndex: 'nomina_aplicacion', key: 'nomina_aplicacion', width: 220,
    },
    {
      titleText: 'Periodo de Nómina de Aplicación', dataIndex: 'periodo_aplicacion_descripcion', key: 'periodo_aplicacion_descripcion', width: 300,
    },
    {
      titleText: 'Estatus', dataIndex: 'estados_globales', key: 'estados_globales', width: 150, render: (val) => estados?.find((e) => e?.id === (val?.id ?? val))?.descripcion,
    },
  ];

  const selectedRecord = data?.find((e) => e?.id === selectedRowKeys[0]);
  const isAutorizado = (selectedRecord?.estados_globales?.id ?? selectedRecord?.estados_globales) === ESTATUS_AUTORIZADO;

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          // === VISTA 1: EXCLUSIVAMENTE LA TABLA (Igual que Incidencias) ===
          <Table
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd, // Esto activa la vista 2
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            customActions={[
              {
                onClick: () => setConfirmationVisible(true),
                permission: { model: 'descuentonominanoaplicado', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length || isAutorizado,
              },
            ]}
            permission={permission}
            allowExportPDF={false}
          />
        ) : (
          // === VISTA 2: FORMULARIO DE CREAR/EDITAR (Con Lupa y botones de Guardar) ===
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Descuento No Aplicado`}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
                onFinishText="Guardar y Continuar" // ¡Acá están los botones que pedías!
              />
            )}
            bordered={false}
          >
            <Form layout="vertical" form={form} scrollToFirstError name="general">
              {/* Campo oculto para manejar el ID real del empleado en el payload */}
              <Form.Item name="empleado" hidden><Input /></Form.Item>

              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  {/* Aquí colocamos la Lupa de búsqueda */}
                  <Form.Item name="empleado_search" label="No. y Nombre del Empleado" rules={rules.required}>
                    <Input.Search
                      allowClear
                      loading={loading}
                      onSearch={() => {
                        setSelectedEmpleadoSearch();
                        setVisibleSearch(true);
                      }}
                      enterButton={<SearchOutlined />}
                      readOnly
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item label="Puesto">
                    <Input allowClear disabled value={puesto} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item label="No. de Plaza">
                    <Input allowClear disabled value={plaza} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item label="Área">
                    <Input allowClear disabled value={area} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="descuento_empleado" label="No. de Descuento" rules={rules.required} hasFeedback>
                    <Select keyProp="id" labelProp="clave" dataSource={descuentosEmpleados} disabled={!empleado} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="periodo_de_nomina_detalle" label="Periodo de Nómina" rules={rules.required} hasFeedback>
                    <Select
                      keyProp="id"
                      dataSource={periodos}
                      render={(p) => `${p?.numero_de_nomina} (${p?.fecha_inicial} al ${p?.fecha_final})`}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <CurrencyInput name="importe_descuento" label="Importe del Descuento" rules={rules.required} hasFeedback />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <CurrencyInput name="importe_aplicado" label="Importe Aplicado" hasFeedback />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <CurrencyInput name="importe_no_aplicado" label="Importe No Aplicado" hasFeedback />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="nomina_aplicacion" label="No. de Nómina de Aplicación" hasFeedback>
                    <Select
                      keyProp="id"
                      dataSource={periodosNominas}
                      render={(p) => `${p?.numero_de_nomina || p?.id}`}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="periodo_de_nomina_detalle_aplicacion" label="Periodo de Nómina de Aplicación" hasFeedback>
                    <Select
                      keyProp="id"
                      dataSource={periodos}
                      render={(p) => `${p?.numero_de_nomina} (${p?.fecha_inicial} al ${p?.fecha_final})`}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="estados_globales"
                    label="Estatus"
                    rules={rules.estatus}
                    hasFeedback
                    initialValue={1}
                  >
                    <Select
                      labelProp="descripcion"
                      keyProp="id"
                      dataSource={estados}
                      disabled={!selectedRowKeys.length}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Card>
        )}

        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content="el Descuento No Aplicado"
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmation}
          onFinishText="Autorizar"
          onCancel={() => setConfirmationVisible(false)}
          open={confirmationVisible}
          title="Confirmación"
          contentTitle="¿Autorizar el Descuento No Aplicado?"
          subContent="Esta acción no podrá revertirse"
          loading={loading}
        />
        <CustomSearch
          form={form}
          open={openSearch}
          setVisible={setVisibleSearch}
          modalTitle="Buscar Empleado"
          firstInputLabel="No. de Empleado"
          firstInputName="numero_de_empleado"
          secondInputLabel="Nombre del Empleado"
          secondInputName="nombre"
          searchInputLabel="Apellido Paterno"
          searchInputName="apellido_paterno"
          thirdInputLabel="Apellido Materno"
          thirdInputName="apellido_materno"
          firstSelectLabel="Tipo de Nómina Empleado"
          firstSelectName="tipo_de_nomina_empleado"
          firstSelectDataSource={tiposDeNominaEmpleado}
          inputsNeeded={3}
          selectsNeeded={1}
          paginatedTable
          modalWidth={1400}
          columns={columnsEmpleado}
          baseURI={baseURIPagination}
          setSelectedRow={setSelectedEmpleadoSearch}
          onFinishGet={getEmpleadosConDatosOpFilteredPaginated}
          data={dataSearch}
          setData={setDataSearch}
          searchData={searchData}
          onChange={onChangeEmpleado}
        />
      </Spin>
    </Row>
  );
};

export default DescuentosNoAplicados;
